import React, { useCallback, useMemo, useState } from 'react';
import { MathUtils } from 'three';

import { ProgressBar } from '../components/progress-bar/progress-bar';

export function useProgressBar(options?: { hideWhenIdle?: boolean }) {
  const [progress, setProgress] = useState(0);
  const [progressText, setProgressText] = useState<string>();

  const onProgress = useCallback(
    (event: { current: number; total: number; label?: string | null }) => {
      const percentage = MathUtils.clamp(event.current / event.total, 0, 1);
      setProgress(percentage);

      if (event.label !== undefined) {
        setProgressText(event.label === null ? undefined : event.label);
      }
    },
    [],
  );

  const renderProgressBar = useCallback(() => {
    const hideProgressBar = options?.hideWhenIdle ? progress === 0 || progress === 1 : false;

    if (hideProgressBar) {
      return null;
    }

    return <ProgressBar max={1} min={0} text={progressText} value={progress} />;
  }, [progress, options, progressText]);

  const isIdle = useMemo(() => {
    return progress === 0 || progress === 1;
  }, [progress]);

  return { renderProgressBar, onProgress, isIdle };
}
